import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AdminNotificationsPage } from '@/pages/admin-notifications';
import { adminNotificationsSearchSchema } from '@/routes/-shared/adminNotificationsSearchSchema';

/**
 * La lista resta montata e il dettaglio della notifica si apre sopra di lei
 * sull'`Outlet` (`$id`), come nella webapp: chiudere il pannello torna alla
 * lista con filtri e scorrimento di prima.
 */
export const Route = createFileRoute('/admin/_layout/notifications/_layout')({
  component: AdminNotificationsLayout,
  validateSearch: adminNotificationsSearchSchema,
});

function AdminNotificationsLayout() {
  return (
    <>
      <AdminNotificationsPage />
      <Outlet />
    </>
  );
}
